export enum FetchStatus {
    FETCHING,
    IDLE,
    ERROR,
    DONE
}

